import React, { useState } from "react";
import classNames from "classnames";
import styles from "./DropdownSelect.module.scss";

const defaultOptions = [
  "Age Group",
  "Education",
  "Gender",
  "Household Income",
  "Marital Status",
];

interface DropdownSelectProps {
  label?: string;
  options?: string[];
  defaultOption?: string;
  onSelect?: (value: string) => void;
}

const DropdownSelect: React.FC<DropdownSelectProps> = ({
  label = "Demographic Type",
  options = defaultOptions,
  defaultOption = "Age Group",
  onSelect = () => {},
}) => {
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  const handleSelect = (value: string) => {
    setSelectedOption(value);
    onSelect(value);
  };

  return (
    <div className={styles.dropdownWrapper}>
      <div className={styles.labelContainer}>
        <label htmlFor="demographic-select" className={styles.label}>
          {label}
        </label>
      </div>
      <div className={styles.selectContainer}>
        <select
          id="demographic-select"
          className={classNames(styles.selectBox, styles.nativeSelect)}
          value={selectedOption}
          onChange={(e) => handleSelect(e.target.value)}
        >
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DropdownSelect;
